// extracted by mini-css-extract-plugin
export default {"publishedVideoMain":"editor-pending-publication_publishedVideoMain__6oheL","publishVideoTable":"editor-pending-publication_publishVideoTable__dKyFh"};